import { actionCreator, ActionReturnType, Loading, loadingNotStarted, loadingIsLoading, loadingFinished, loadingFailed } from "@itk/typescript-utils";
import { Model_ConfigurationQueryAttributeFilterPost, Model_ConfigurationQueryFilterGet, Model_ConfigurationQueryFilterPost, Model_ConfigurationQueryLabelFilterPost } from "src/backend/openapi/v1";

export enum Action {
  GetFiltersRequest = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:FILTER:FILTER-STORE.TS:ACTION:GETFILTERSREQUEST",
  GetFiltersSuccess = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:FILTER:FILTER-STORE.TS:ACTION:GETFILTERSSUCCESS",
  GetFiltersFail = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:FILTER:FILTER-STORE.TS:ACTION:GETFILTERSFAIL",

  SetIsFilterOpen = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:FILTER:FILTER-STORE.TS:ACTION:SETISFILTEROPEN",
  SetFormData = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:FILTER:FILTER-STORE.TS:ACTION:SETFORMDATA",
  SetFormDataAttributes = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:FILTER:FILTER-STORE.TS:ACTION:SETFORMDATAATTRIBUTES",
  SetFormDataLabels = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:FILTER:FILTER-STORE.TS:ACTION:SETFORMDATALABELS",
  ResetFormData = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:FILTER:FILTER-STORE.TS:ACTION:RESETFORMDATA",

  Clear = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:FILTER:FILTER-STORE.TS:ACTION:CLEAR"
}

type IFilterState = {
  filterState: Loading<Model_ConfigurationQueryFilterGet>;
  isFilterOpen: boolean;
  formData: Model_ConfigurationQueryFilterPost;
};

const initialState: IFilterState = {
  filterState: loadingNotStarted,
  isFilterOpen: false,
  formData: {
    attributes: [],
    labels: []
  }
};

export const filterActions = {
  getFiltersRequest: (projectId: string) => actionCreator(Action.GetFiltersRequest, { projectId }),
  getFiltersSuccess: (data: Model_ConfigurationQueryFilterGet) => actionCreator(Action.GetFiltersSuccess, { data }),
  getFiltersFail: () => actionCreator(Action.GetFiltersFail),

  setIsFilterOpen: (data: boolean) => actionCreator(Action.SetIsFilterOpen, { data }),
  setFormData: (data: Model_ConfigurationQueryFilterPost) => actionCreator(Action.SetFormData, { data }),
  setFormDataAttributes: (attribute: Model_ConfigurationQueryAttributeFilterPost) => actionCreator(Action.SetFormDataAttributes, { attribute }),
  setFormDataLabels: (labels: Model_ConfigurationQueryLabelFilterPost[]) => actionCreator(Action.SetFormDataLabels, { labels }),
  resetFormData: () => actionCreator(Action.ResetFormData),

  clear: () => actionCreator(Action.Clear)
};

export const filterReducer = (state = initialState, action: ActionReturnType<typeof filterActions>): IFilterState => {
  switch (action.type) {
    case Action.GetFiltersRequest:
      return { ...state, filterState: loadingIsLoading };
    case Action.GetFiltersSuccess:
      return { ...state, filterState: loadingFinished(action.payload.data) };
    case Action.GetFiltersFail:
      return { ...state, filterState: loadingFailed };

    case Action.SetIsFilterOpen:
      return { ...state, isFilterOpen: action.payload.data };

    case Action.SetFormData:
      return { ...state, formData: action.payload.data };
    case Action.SetFormDataAttributes:
      const newAttributes = [...(state.formData.attributes || [])];

      const index = newAttributes.findIndex(x => x.id === action.payload.attribute.id);
      if (index >= 0) {
        newAttributes[index].values = action.payload.attribute.values;
      } else {
        newAttributes.push(action.payload.attribute);
      }
      return {
        ...state,
        formData: {
          ...state.formData,
          attributes: newAttributes
        }
      };
    case Action.SetFormDataLabels:
      return { ...state, formData: { ...state.formData, labels: action.payload.labels } };

    case Action.ResetFormData:
      return { ...state, formData: initialState.formData };

    case Action.Clear:
      return initialState;
    default:
      return state;
  }
};
